import { render, staticRenderFns } from "./PainelLoteLegadoTabela.vue?vue&type=template&id=61961eef&scoped=true"
import script from "./PainelLoteLegadoTabela.vue?vue&type=script&lang=js"
export * from "./PainelLoteLegadoTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelLoteLegadoTabela.vue?vue&type=style&index=0&id=61961eef&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61961eef",
  null
  
)

export default component.exports